<!--
 * @Descripttion: 车辆视频
 * @version: 
 * @Author: szj
 * @Date: 2024-05-25 13:52:00
 * @LastEditors: szj
 * @LastEditTime: 2025-01-09 13:33:46
-->
<template>
  <div
    :id="containerId"
    :ref="containerId"
    style="width: 100%; height: 100%"
  ></div>
</template>
<script setup lang="ts">
import { watch } from "vue";

let jessibuca = null as any; //视频播放器
const props = defineProps({
  // 元素节点
  containerId: {
    type: String,
    default: () => {
      return "players";
    },
  },
  // 视频地址
  videoUrl: {
    type: String,
    default: () => {
      return "";
    },
  },
});
// 监听视频地址
watch(
  () => props.videoUrl,
  (url) => {
    console.log(40,url,props.containerId);
    
    if (url) {
      loadVideo(url);
    }
  },{
    deep: true,
    immediate: true,
  }
);
// 播放视频
function loadVideo(vedio_url: string) {
  let video = document.getElementById(`${props.containerId}`);
  console.log(52,video);
  
  if (!video) {
    return;
  }
  let options = {};
  jessibuca = new window.Jessibuca(
    Object.assign(
      {
        container: video,
        videoBuffer: 0.2, // 最大缓冲时长，单位秒
        isResize: true,
        decoder: "/js/jessibuca/decoder.js",
        useMSE: false,
        showBandwidth: false,
        isFlv: true,
        // text: "WVP-PRO",
        // background: "static/images/zlm-logo.png",
        loadingText: "加载中",
        hasAudio: true,
        debug: false,
        supportDblclickFullscreen: false, // 是否支持屏幕的双击事件，触发全屏，取消全屏事件。
        operateBtns: {
          fullscreen: false,
          screenshot: false,
          play: false,
          audio: false,
          recorder: false,
        },
        record: "record",
        vod: true,
        // forceNoOffscreen: false,
        isNotMute: false,
      },
      options
    )
  );
  if (jessibuca.hasLoaded()) {
    jessibuca.play(vedio_url);
  } else {
    jessibuca.on("load", () => {
      jessibuca.play(vedio_url);
    });
  }
}
// 关闭视频
function closeVideo() {
  if (jessibuca) {
    jessibuca.destroy();
  }
}
</script>
